<template>
  <div/>
</template>

<script>
import { mapGetters } from 'vuex'
import { Howler, Howl } from 'howler'
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    loop: {
      type: Boolean,
      default: true
    },
    volume: {
      type: Number,
      default: 1
    }
  },
  mounted () {
    Howler.autoUnlock = false
    this.howl = this.createHowl()
  },
  computed: mapGetters('ui', [
    'muted'
  ]),
  watch: {
    muted (val) {
      this.howl.mute(val)
    }
  },
  methods: {
    createHowl () {
      return new Howl({
        src: this.url,
        loop: this.loop,
        volume: this.volume
      })
    },
    play () {
      this.howl.pause()
      this.howl.play()
    },
    fade (state) {
      this.howl.fade(
        state ? 0 : 1,
        state ? 1 : 0,
        1000
      )
    }
  }
}
</script>
